import type { Lang } from "@/i18n/language";

export type EmailTemplateRow = {
  id: string;
  slug: string;
  name_es: string;
  name_en: string;
  subject_es: string;
  subject_en: string;
  body_es: string;
  body_en: string;
  button_label_es: string;
  button_label_en: string;
  signature_es: string;
  signature_en: string;
  header_image_url: string | null;
};

export type TemplateVars = {
  nombre?: string;
  grupo?: string;
  fecha?: string;
  enlace?: string;
};

export function fillVars(text: string, vars: TemplateVars) {
  return text.replace(/\{\{\s*(nombre|grupo|fecha|enlace)\s*\}\}/g, (_m, key: string) => {
    const value = vars[key as keyof TemplateVars];
    return value && value.trim() ? value : `{{${key}}}`;
  });
}

export function renderTemplate(template: EmailTemplateRow, lang: Lang, vars: TemplateVars) {
  const pick = (es: string, en: string) => (lang === "es" ? es : en);
  return {
    subject: fillVars(pick(template.subject_es, template.subject_en), vars),
    body: fillVars(pick(template.body_es, template.body_en), vars),
    buttonLabel: pick(template.button_label_es, template.button_label_en),
    signature: pick(template.signature_es, template.signature_en),
    headerImage: template.header_image_url,
  };
}
